import Checkbox from '@/components/Checkbox'

export interface Filter {
  hideAwaitingResponseOutcome: boolean
}

export const DEFAULT_FILTER: Filter = {
  hideAwaitingResponseOutcome: true,
}

export interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const FraudSettingsFilter = ({ filter, onChangeFilter }: Props) => {
  return (
    <Checkbox
      label="Just show today's queue"
      checked={filter.hideAwaitingResponseOutcome}
      onChange={e => {
        onChangeFilter({
          hideAwaitingResponseOutcome: e.target.checked,
        })
      }}
    />
  )
}

export default FraudSettingsFilter
